var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-box"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div')]),_c('div',{staticClass:"picker-country"})])
}
var staticRenderFns = []

export { render, staticRenderFns }